<template>
  <div class="grid-view">
    <div class="main-content">
      <div class="operations" style="margin-top: 5px">
        <div class="filters">
          <el-form
            :inline="true"
            label-width="50px"
            label-position="left"
            @submit.native.prevent="filter.pageNum=1;toQuery()"
          >
            <el-form-item :label="$t('common.btn.query')">
              <el-input
                v-model="filter.likeName"
                :placeholder="$t('CargoMsg.Cargo_EnterKeyWordsToStartFuzzySearch')"
                style="width:310px"
              />
            </el-form-item>
          </el-form>
        </div>
        <div class="triggers">
          <div>
            <el-button type="primary" @click="filter.pageNum=1;toQuery()">{{ $t('common.btn.query') }}</el-button>
            <el-button type="primary" @click="addHandler">{{ $t('common.btn.new') }}</el-button>
            <el-button type="primary" @click="editHandler">{{ $t('common.btn.edit') }}</el-button>
            <el-button type="danger" @click="removeHandler">{{ $t('common.btn.delete') }}</el-button>
            <el-button v-if="showBtn" type="primary" @click="onSendEmail">{{ $t('Information.EmailRemindertestOnly') }}</el-button>
            <el-button v-if="showBtn" type="primary" @click="onSplit">{{ $t('Information.SplitDataBecomesNewData') }}</el-button>
            <el-upload
              ref="upload"
              :action="URL.mdm.sensitiveWord.importSensitiveWordUrl"
              :headers="{sessionId, language: $store.getters.language === 'zh' ? 'zh_CN' : ($store.getters.language === 'ja' ? 'ja_JP' : 'en_US')}"
              :show-file-list="false"
              accept=".xls, .xlsx"
              :before-upload="beforeOrderUpload"
              :on-error="handleError"
              :on-success="uploadExcelSuccess"
              :data="{ branchId: $store.getters.currentOfficeId, wordField: wordField }"
              style="display: inline-block; margin-left: 5px;"
            >
              <el-button type="primary">{{ $t('SeaExport.import') }}</el-button>
            </el-upload>
            <el-button type="primary" @click="downLoadTemplate()">{{ $t('CargoMsg.Cargo_DownImportTemplate') }}</el-button>
          </div>
        </div>
      </div>
      <div class="section grid-wrapper">
        <cargo-ag-grid
          config-module="1001022"
          :grid-options="gridOptions"
          :column-defs="columnDefs"
          :row-data="rowData"
          @gridReady="params=>{gridApi=params.api}"
        />
      </div>
      <div class="pagination-wrapper">
        <cargo-pagination
          v-show="total>0"
          :total="total"
          :page.sync="filter.pageNum"
          :limit.sync="filter.pageSize"
          @pagination="toQuery"
        />
      </div>
      <sensitive-add-dialog
        :visible.sync="addDialogVisible"
        :word-field="wordField"
        @refreshGrid="toQuery()"
        @close="addDialogVisible=false"
      />
      <sensitive-edit-dialog
        :visible.sync="editDialog.visible"
        :word-uuid="editDialog.wordUuid"
        :word-field="wordField"
        @refreshGrid="toQuery()"
        @close="editDialog.visible=false"
      />
      <import-result
        :visible="importResultDialog.visible"
        :result="importResultDialog.result"
        @continueImporting="continueImporting"
        @close="closeImportResultDialog"
      />
    </div>
  </div>
</template>

<script>
import { getLoading } from '@/utils/utilBaseElement'
import * as sensitiveWordApi from '@/api/basicData/sensitiveWord'
import SensitiveAddDialog from '@/views/cargo/v0/Information/components/sensitiveWord/SensitiveAddDialog'
import SensitiveEditDialog from '@/views/cargo/v0/Information/components/sensitiveWord/SensitiveEditDialog'
import { exportExcel } from '@/utils/tableDataExportUtils'
import ColumnUtils from '@/utils/ColumnUtils'
import CustomLableUtils from '@/utils/CustomLabelUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import URL from '@/api/urlTranslator'
import { ExportUtils } from '@/class/cargo/model/utils/ExportUtils'
import ImportResult from '@/views/cargo/v0/SeaExport/Vessel/components/importResult'

export default {
  name: 'TabSensitiveConfig',
  components: { ImportResult, SensitiveAddDialog, SensitiveEditDialog },
  props: {
    wordField: { type: Number, required: true }
  },
  data() {
    return {
      filter: {
        likeName: '',
        pageNum: 1,
        pageSize: 50
      },
      total: 0,
      girdParams: {},
      gridApi: null,
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        defaultColDef: {
          menuTabs: [] // 去掉每列的菜单
        },
        suppressContextMenu: false, // 右键列表弹出菜单
        getContextMenuItems: () => {
          const self = this
          return [
            {
              name: self.$t('CargoMsg.Cargo_ExcelExport'),
              action: function() {
                self.exportExcelHandler()
              }
            }
          ]
        }
      },
      columnDefs: [
        {
          headerName: '', checkboxSelection: true, width: 55, pinned: 'left',
          sortable: false, suppressMenu: true, suppressSizeToFit: true,
          resizable: false, headerCheckboxSelection: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_KeyWord'),
          field: 'words',
          width: 150
        },
        {
          headerName: this.$t('CargoMsg.Cargo_ApplicationBranch1'),
          field: 'multipleBranchId',
          width: 150,
          valueFormatter: params => {
            if (params.value) {
              const values = params.value.split(',')
              const names = []
              for (const val of values) {
                if (val === '0') {
                  names.push(this.$t('Message.All'))
                } else {
                  names.push(ColumnUtils.getOfficeLabel('officeId', Number(val)))
                }
              }
              return names.join(',')
            }
            return ''
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_BusinessType'),
          field: 'multipleLob',
          width: 150,
          valueFormatter: params => {
            if (params.value) {
              const values = params.value.split(',')
              const names = []
              for (const val of values) {
                if (val === 'ALL') {
                  names.push(this.$t('Message.All'))
                } else {
                  names.push(ColumnUtils.fbaJobBussStateLabelFunc(val))
                }
              }
              return names.join(',')
            }
            return ''
          }
        },
        {
          headerName: this.$t('Information.SeaAirRoutes'),
          field: 'multipleRegion',
          width: 150,
          valueFormatter: params => {
            if (params.value) {
              const values = params.value.split(',')
              const names = []
              for (const val of values) {
                if (val === ' ') {
                  names.push(this.$t('Message.All'))
                } else {
                  names.push(ColumnUtils.resolveColumnLabelV2(TYPE_NAMES.basic_data_Region, 'code', val, 'name'))
                }
              }
              return names.join(',')
            }
            return ''
          }
        },
        {
          headerName: this.$t('Information.AppliedSeaport'),
          field: 'multipleSeaPort',
          width: 150,
          valueFormatter: params => {
            if (params.value) {
              const values = params.value.split(',')
              const names = []
              for (const val of values) {
                if (val === ' ') {
                  names.push(this.$t('Message.All'))
                } else {
                  names.push(CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Seaport, 'code', val, 'auto_7'))
                }
              }
              return names.join(',')
            }
            return ''
          }
        },
        {
          headerName: this.$t('Information.AppliedShippingCompany'),
          field: 'multipleSeaCmp',
          width: 150,
          valueFormatter: params => {
            if (params.value) {
              const values = params.value.split(',')
              const names = []
              for (const val of values) {
                if (val === '0') {
                  names.push(this.$t('Message.All'))
                } else {
                  names.push(CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(val), 'auto_5'))
                }
              }
              return names.join(',')
            }
            return ''
          }
        },
        {
          headerName: this.$t('Information.ApplicationAirport'),
          field: 'multipleAirPort',
          width: 150,
          valueFormatter: params => {
            if (params.value) {
              const values = params.value.split(',')
              const names = []
              for (const val of values) {
                if (val === ' ') {
                  names.push(this.$t('Message.All'))
                } else {
                  names.push(CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Airport, 'code', val, 'auto_8'))
                }
              }
              return names.join(',')
            }
            return ''
          }
        },
        {
          headerName: this.$t('Information.AppliedAirlines'),
          field: 'multipleAirCmp',
          width: 150,
          valueFormatter: params => {
            if (params.value) {
              const values = params.value.split(',')
              const names = []
              for (const val of values) {
                if (val === '0') {
                  names.push(this.$t('Message.All'))
                } else {
                  names.push(CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(val), 'auto_6'))
                }
              }
              return names.join(',')
            }
            return ''
          }
        }
      ],
      rowData: [],
      addDialogVisible: false,
      editDialog: {
        visible: false,
        wordUuid: ''
      },
      URL,
      fullscreenLoading: null,
      importResultDialog: {
        visible: false,
        result: {}
      }
    }
  },
  computed: {
    showBtn() {
      return this.$store.getters.tenantId === 1 || this.$store.getters.isAdmin
    },
    language() {
      return this.$store.getters.language === 'zh' ? 'chineseName' : 'englishName'
    },
    sessionId() {
      return this.$store.getters.token
    }
  },
  watch: {
  },
  created() {
    this.onShow()
  },
  methods: {
    onShow() {
      this.toQuery()
    },
    toQuery() {
      const params = { ...this.filter }
      params.wordField = this.wordField
      const loading = getLoading()
      sensitiveWordApi.queryByCondition(params).then(resp => {
        this.rowData = resp.data.list
        this.filter.pageNum = resp.data.pageNum
        this.filter.pageSize = resp.data.pageSize
        this.total = Number(resp.data.total)
      }).finally(() => loading.close())
    },
    addHandler() {
      this.addDialogVisible = true
    },
    editHandler() {
      const selectedRows = this.gridOptions.api.getSelectedRows()
      if (!selectedRows || selectedRows.length === 0) {
        this.$message.warning(this.$t('Message.PleaseSelectARecord'))
        return
      } else if (selectedRows.length > 1) {
        this.$message.warning(this.$t('CargoMsg.Cargo_DoNotSelectMultipleItems'))
        return
      }
      this.editDialog.wordUuid = selectedRows[0].uuid
      this.editDialog.visible = true
    },
    removeHandler() {
      const selectedRows = this.gridOptions.api.getSelectedRows()
      if (!selectedRows || selectedRows.length === 0) {
        this.$message.warning(this.$t('Message.PleaseSelectARecord'))
        return
      }
      this.$confirm(this.$t('Message.SureDelete'), this.$t('Message.Prompt'), { closeOnClickModal: false }).then(() => {
        const uuids = selectedRows.map(row => row.uuid)
        sensitiveWordApi.removeBatch(uuids).then(() => {
          this.$message.success(this.$t('Message.DeleteSuccessfully'))
          this.toQuery()
        })
      })
    },
    // 将原来的一条数据分割成多条数据并保存
    onSplit() {
      const selectedRows = this.gridOptions.api.getSelectedRows()
      if (!selectedRows || selectedRows.length === 0) {
        this.$message.warning(this.$t('Message.PleaseSelectARecord'))
        return
      } else if (selectedRows.length > 1) {
        this.$message.warning(this.$t('CargoMsg.Cargo_DoNotSelectMultipleItems'))
        return
      }
      const sensitiveWord = selectedRows[0]
      const w = sensitiveWord.words
      if (w.indexOf(',') > 0 || w.indexOf('，') > 0) {
        this.$confirm(this.$t('Information.SplittingDataAreYouSplit'), this.$t('Message.Prompt'), { closeOnClickModal: false }).then(() => {
          sensitiveWordApi.splitSensitiveWord({ uuid: sensitiveWord.uuid }).then(resp => {
            this.splitSensitiveWordHandler(resp)
          })
        })
      } else {
        this.$message.warning(this.$t('CargoMsg.Cargo_NoNeedToSplitThisKeyWord'))
      }
    },
    splitSensitiveWordHandler(resp) {
      const result = resp.data
      if (result > 0) {
        this.$message.success(this.$t('Information.SplitSuccessfullySplitInto') + result + this.$t('Message.SensitiveWords'))
      }
      this.toQuery()
    },
    // 邮件提醒
    onSendEmail() {
      sensitiveWordApi.sendEmailSensitiveWord().then(resp => {
        this.$message.success(this.$t('CargoMsg.Cargo_EMSSCM'))
        this.toQuery()
      })
    },
    exportExcelHandler() {
      const columnDefs = []
      this.columnDefs.forEach(column => columnDefs.push({ colDef: column }))
      exportExcel(this.$t('Information.SensitiveWordManagement'), this.rowData, columnDefs)
    },
    downLoadTemplate() {
      ExportUtils.downloadTemplateFile('SensitiveWordTemplate.xlsx', 'mdm')
    },
    beforeOrderUpload(file) {
      this.fullscreenLoading = getLoading()
      const fileType = file.name.substring(file.name.lastIndexOf('.') + 1)
      const extension = fileType === 'xls'
      const extension2 = fileType === 'xlsx'
      if (!extension && !extension2) {
        this.fullscreenLoading.close()
        this.$message.warning(this.$t('SeaExport.FileOnlyXlsXlsx'))
      }
      return extension || extension2
    },
    handleError(error) {
      const errorData = JSON.parse(error.message)
      this.$message.error({ 'message': errorData.message, 'duration': 15000 })
      this.fullscreenLoading.close()
    },
    uploadExcelSuccess(response, file, fileList) {
      this.$refs.upload.clearFiles()
      this.fullscreenLoading.close()
      if (response && response.data) {
        if (response.data.hasOwnProperty('errorMsg')) {
          this.$message.error(response.data.errorMsg)
          return
        }
        this.importResultDialog.visible = true
        this.importResultDialog.result = response.data
      } else {
        this.$message.error(this.$t('SeaExport.ImportFailedContactAdministrator'))
      }
    },
    continueImporting() {
      this.importResultDialog.visible = false
      this.$refs['upload'].$refs['upload-inner'].$refs.input.click()
    },
    closeImportResultDialog() {
      this.importResultDialog.visible = false
    }
  }
}
</script>

<style scoped>

</style>
